import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventColor extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventColor';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            primary: null,
            primaryLight: null,
            primaryDarker: null,
            background: null,
            menuBG: null,
            menuText: null,
            menuIcon: null,
            menuTintBG: null,
            menuTint: null,
            menuTintIcon: null,
            statusBG: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.EventColor) {
    //         data.EventColor = new models.api.EventColor(data.EventColor)
    //     }
    //     return data
    // }
}

const servicePath = 'events-color';
const servicePlugin = makeServicePlugin({
    Model: EventColor,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin